import { createSelector } from "@ngrx/store";

import { RegData } from "../core/dtos/reg-data";
import { AppState } from "./app.state";

export const selectRegData = createSelector(
  (state: AppState) => state.regData,
  (regData: RegData) => regData
);

export const selectTestPurposeOption = createSelector(
  selectRegData,
  (regData: RegData) => regData.selectedTestPurposeOption
);

export const selectRegTestSession = createSelector(
  selectRegData,
  (regData: RegData) => regData.testSession
);

export const selectProofOfIdentity = createSelector(
  selectRegData,
  (regData: RegData) => regData.proofOfIdentity
);

export const selectScoreReport = createSelector(
  selectRegData,
  (regData: RegData) => regData.scoreReport
);

export const selectTestPurposeLookup = createSelector(
  selectRegData,
  (regData: RegData) => regData.lookup.testPurposes
);

export const selectInstitutionLookup = createSelector(
  selectRegData,
  (regData: RegData) => regData.lookup.institutions
);

export const selectCollegeLookup = createSelector(
  selectRegData,
  (regData: RegData) => regData.lookup.subscribedInstitutions
);
